import { useLoadingStore } from '@/store/useLoadingStore'
import LogoLoading from '@/assets/svgs/LogoLoading.svg'
import { useDialogVisibility } from '@/hooks/useDialogVisiibility'
import * as S from './styles'

export const Loading = () => {
  const isLoading = useLoadingStore((state) => state.isLoading)
  const loadingContent = useLoadingStore((state) => state.loadingContent)
  const { dialogRef } = useDialogVisibility(isLoading)

  if (!isLoading) {
    return null
  }

  return (
    <S.Dialog ref={dialogRef}>
      <S.Content>
        <S.ImageWrapper>
          <img src={LogoLoading} alt="Carregando..." height={81} width={100} />
        </S.ImageWrapper>
        {loadingContent}
      </S.Content>
    </S.Dialog>
  )
}
